// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// Became Possible components
import MDBox from "components/MDBox";

function DataTableBodyCell({ noBorder, align, children, bgColor }) {
  return (
    <MDBox
      component="td"
      textAlign={align}
      py={1.5}
      px={1}
      bgColor={bgColor}
      sx={({ palette: { light }, typography: { size }, borders: { borderWidth } }) => ({
        fontSize: size.sm,
        borderBottom: noBorder ? "none" : `${borderWidth[1]} solid ${light.main}`,
      })}
    >
      <MDBox
        display="inline-block"
        // width="max-content"
        width="fit-content"
        color="dark"
        sx={{ verticalAlign: "middle" }}
      >
        {children}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of DataTableBodyCell
DataTableBodyCell.defaultProps = {
  noBorder: false,
  align: "left",
  // width: "auto",
  bgColor: null,
};

// Typechecking props for the DataTableBodyCell
DataTableBodyCell.propTypes = {
  children: PropTypes.node.isRequired,
  noBorder: PropTypes.bool,
  align: PropTypes.oneOf(["left", "right", "center"]),
  // width: PropTypes.string,
  bgColor: PropTypes.string,
};

export default DataTableBodyCell;
